import { createContext, useContext } from 'react';
import { IFormRuntimeContext, QuestionStyle, QuestionStyleTypes } from './contracts';

export const FormRuntimeContext = createContext<IFormRuntimeContext | null>(null);

FormRuntimeContext.displayName = 'FormRuntimeContext';

export const useFormRuntimeContext = (): IFormRuntimeContext => {
	const context = useContext(FormRuntimeContext);
	if (!context) {
		throw new Error('useFormRuntimeContext must be used within a FormRuntimeContextProvider');
	}
	return context;
};

export const useQuestionStyle = (questionStyleType: QuestionStyleTypes, fallback: QuestionStyle, questionId?: string) => {
	const { getQuestionStyle } = useContext(FormRuntimeContext) ?? {};
	if (!getQuestionStyle) {
		throw new Error('useQuestionStyle must be used within a FormRuntimeContextProvider');
	}
	return getQuestionStyle(questionStyleType, fallback, questionId);
};
